import { LikeObserver } from '@widgets/like-product';

import { LikeButton } from '../components/LikeButton';
import { ReviewButton } from '../components/ReviewButton';
import { useSubButtonLog } from '../log/useSubButtonLog';
import { useInAppSubButtonsService } from '../services/useInAppSubButtonsService';

interface Props {
  product_id: string;
}
export function InAppSubButtonContainer({ product_id }: Props) {
  const service = useInAppSubButtonsService();
  const log = useSubButtonLog();

  return (
    <>
      <ReviewButton
        isLoading={service.isLoading}
        review_prediction_rating={service.review_prediction_rating}
        has_review_event={service.has_review_event}
        total_count={service.review_total_count}
        onClick={() => {
          log.reviewClickUBL();
          service.goToReviewList();
        }}
      />
      <LikeObserver catalogProductId={product_id}>
        {({ isLiked, ref }) => (
          <LikeButton
            ref={ref}
            isSaved={isLiked}
            onClick={() => {
              service.onHeartClick(isLiked);
            }}
          />
        )}
      </LikeObserver>
    </>
  );
}
